export default __webpack_public_path__ + "static/media/toyko.0fdc3c13.png";